import { gql, useQuery } from '@apollo/client'
import { useState } from 'react'

import {
  PreSaleLotteryApplicantsFragmentDoc,
  PreSaleLotteryApplicantsQuery,
  PreSaleLotteryApplicantsQueryVariables,
} from '@/clients/utoniq-core/schema'
import { makeViewModel } from '@/core/architecture'
import { useCurrentUser } from '@/core/auth'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { user } = useCurrentUser()
  const options = [
    { value: undefined },
    { value: '10_win' },
    { value: '11_win_paid' },
    { value: '20_waiting_payment' },
    { value: '30_waiting_lottery' },
    { value: '40_lose' },
    { value: '50_invalid' },
  ]
  const params = new URLSearchParams(window.location.search)
  const eventFilter = params.get('filter') ?? 'general'

  const value =
    options.find(option => option.value === eventFilter)?.value ?? 'general'

  const [filter, setFilter] = useState(value)
  const { data, loading, refetch, fetchMore } = useQuery<
    PreSaleLotteryApplicantsQuery,
    PreSaleLotteryApplicantsQueryVariables
  >(QUERY, {
    variables: {
      filter: filter === 'general' ? undefined : filter,
    },
    notifyOnNetworkStatusChange: true,
  })

  return {
    state: {
      loading,
      lotteryApplications: data?.preSaleLotteryApplicants,
      filter,
    },
    actions: {
      onFilter: (filter: string | undefined) => {
        setFilter(filter ?? 'general')
        refetch({
          filter: filter === 'general' ? undefined : filter,
        })
      },
      async onFetchMore(filter) {
        fetchMore({
          variables: {
            fitlter: filter === 'general' ? undefined : filter,
            pageInput: {
              cursor: data?.preSaleLotteryApplicants?.pageInfo?.endCursor,
            },
          },
        })
      },
    },
  }
})

const QUERY = gql`
  query PreSaleLotteryApplicants($filter: [String!], $pageInput: PageInput) {
    preSaleLotteryApplicants(filter: $filter, pageInput: $pageInput) {
      ...PreSaleLotteryApplicants
    }
  }
  ${PreSaleLotteryApplicantsFragmentDoc}
`
